define(function (require) {

    var BaseTableViewController = require('web-agent-framework/BaseTableViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');

    var VisitorsListWidgetsManager = require('web-agent-viewControllers/VisitorsListWidgetsManager');
    var VisitorListEngagementWidget = require('web-agent-widgets/VisitorListEngagementWidget');
    var VisitInfoWidget = require('web-agent-widgets/VisitInfoWidget');
    var VisitorInfoWidget = require('web-agent-widgets/VisitorInfoWidget');
    var FilterDropdownSelectionViewController = require('web-agent-components/FilterDropdownSelectionViewController');
    var PageNavigationWidget = require('web-agent-widgets/PageNavigationWidget');

    var VisitorListTableViewController = BaseTableViewController.extend({
        ControllerName: "VisitorListTableViewController",
        applicationType: "VisitorListTableViewController",

        LPViewMap: {
        },

        LPClassesMap: {
            negative: "negative",
            positive: "positive",
            neutral: "neutral"
        },

        LPPrefixMap: {
            visitorList: "VISITOR_LIST"
        },
        supportedBrowserIcons: [
            'opera', 'opera_mobile', 'opera_mini',
            'safari', 'safari_mobile',
            'firefox', 'mobile_firefox',
            'msie', 'ie', 'ie_mobile',
            'chrome', 'chrome_mobile',
            'edge', 'microsoft_edge'
        ],

        initialize: function (constructorData) {
            if (constructorData.paging && lpTag.WebAgent.logicController.hasVisitorFeedPreFiltering()) {

            }
        },

        events: function () {
        },

        render: function () {
        }
    });

    VisitorListTableViewController.prototype.getConfiguration = function () {
        var configuration = {
            updateQueryCallback: lpTag.WebAgent.visitorFeedController.updateQuery,
            context: this,
            textsPrefix: this.LPPrefixMap.visitorList,
            tableName: this.applicationType,
            tableRootModelPath: "participants.visitorList",
            globalData: {
                modelController: lpTag.WebAgent.visitorFeedController,
                tableName: this.applicationType,
                textsPrefix: this.LPPrefixMap.visitorList
            },
            tableHead: {
                columnsData: this.getColumnsData()
            },
            tableBody: {
                htmlTable: true,
                ignoreRowHover: true,
                ignoreSectionHover: true,
                rowTemplateFile: 'LP_visitor_list_row.html',
                dataRenderer: this.dataRenderer,
                supportKeysNavigation: true
            },
            paging: {
                pageSize: 50,
                permutation: "A"
            },
            widgets: {
                widgetsManager: VisitorsListWidgetsManager,
                widgetsManagerData: {
                    modelController: lpTag.WebAgent.AppMediator,
                    className: "visitor_list_widgets",
                    itemIdTag: "id",
                    widgetsData: this.getWidgetsData()
                }
            }
        };
        if (lpTag.WebAgent.logicController.hasVisitorFeedPreFiltering()) {
            configuration.paging.permutation = "B";
            configuration.showPagingOnEmptyList = true;
            configuration.emptyEndTableMessageTag = "emptyStart2End";
            configuration.paging.tableItemsNextIndexModelPath = configuration.tableRootModelPath + ".nextIndex";
            configuration.paging.tableItemsPrevIndexModelPath = configuration.tableRootModelPath + ".prevIndex";
            configuration.paging.tableItemsCurrIndexModelPath = configuration.tableRootModelPath + ".currIndex";
        }
        if (!lpTag.WebAgent.logicController.hasSentimentAnalysisFeature()) {
            configuration.tableHead.headerRowClassName = "hide_sentiment";
        }
        if (!agentLEManager.hasLiveEngage2Feature()) {
            configuration.tableHead.headerRowClassName += " hide_devices";
        }
        if (!lpTag.WebAgent.logicController.hasAgentGroupsColumn()) {
            configuration.tableHead.headerRowClassName += " hide_agentGroups";
        }
        return configuration;
    };

    VisitorListTableViewController.prototype.dataRenderer = {
        numberOfSections: function (data) {
            return 1;
        },
        numberOfRowsInSection: function (data, sectionIndex) {
            return data.length;
        },
        dataForSection: function (data, sectionIndex) {
            // The data will be injected to the section template.
        },
        dataForRowInSection: function (data, rowIndex, sectionIndex) {
            var participantInfo = data[rowIndex].participantInfo;
            var value = {};
            value.id = participantInfo.id;
            if (participantInfo) {
                value.className = "";
                value.darkLine = rowIndex % 2 === 0 ? 'dark_line' : '';
                if (participantInfo.agentNickName) {
                    value.activeChatAgentName = participantInfo.agentNickName;
                    value.activeChatAgentNameTooltip = participantInfo.agentNickName;
                    if (participantInfo.displayName) {
                        value.activeChatAgentNameTooltip += " (" + participantInfo.displayName + ")";
                    }
                } else {
                    value.activeChatAgentName = this.translate('notAvailable');
                    value.activeChatAgentNameTooltip = this.translate('notAvailable');
                }
                if (participantInfo.state) {
                    value.state = participantInfo.state.toLowerCase();
                    value.stateTooltip = this.translate('STATE_' + participantInfo.state);
                } else {
                    value.state = this.translate('notAvailable');
                    value.stateTooltip = this.translate('notAvailable');
                }
                if (lpTag.WebAgent.logicController.hasSentimentAnalysisFeature()) {
                    if (participantInfo.sentimentScore !== 'undefined') {
                        var sentimentTag = lpTag.WebAgent.logicController.getSentimentTag(participantInfo.sentimentScore);
                        value.sentiment = this.LPClassesMap[sentimentTag];
                    } else {
                        value.sentiment = "neutral";
                    }
                } else {
                    value.className += "hide_sentiment";
                }
                if (value.sentiment === "neutral") {
                    value.sentimentTooltip = '';
                } else {
                    value.sentimentTooltip = this.translate('SENTIMENT_' + value.sentiment);
                }

                value.disabled = (value.state === 'no_chat' || value.state === 'left_site') ? 'disabled' : '';
                value.serialNumber = '';
                value.participantTag = '';
                value.spectatedOrAccepted = '';
                if (lpTag.WebAgent.logicController.isAcceptedEngagement(participantInfo.id)) {
                    value.spectatedOrAccepted = 'accepted';
                    var participantPath = lpTag.WebAgent.logicController.getParticipantPath(participantInfo.id);
                    value.serialNumber = this.modelController.getModelParam(participantPath + '.participantInfo.visitorSerialNumber');
                    value.participantTag = this.modelController.getModelParam(participantPath + '.participantTag');
                } else if (lpTag.WebAgent.logicController.isSpectatedEngagement(participantInfo.id)) {
                    value.spectatedOrAccepted = 'spectated';
                }
                if (participantInfo.identifier) {
                    value.nameTooltip = participantInfo.identifier;
                } else {
                    value.nameTooltip = this.translate('participantDefaultName');
                }
                value.name = value.nameTooltip;
                if (typeof participantInfo.countryCode === 'undefined' || participantInfo.countryCode === '--') { // No country
                    value.countryCode = '';
                    value.countryTooltip = this.translate('notAvailable');
                } else {
                    value.countryCode = participantInfo.countryCode.toLowerCase();
                    value.countryTooltip = participantInfo.country;
                    if (participantInfo.geoState) {
                        value.countryTooltip = participantInfo.geoState + ', ' + value.countryTooltip;
                    }
                }
                if (participantInfo.skill) {
                    value.skillTooltip = participantInfo.skill;
                    value.skill = participantInfo.skill;
                } else {
                    value.skillTooltip = this.translate('unassigned');
                    value.skill = this.translate('unassigned');
                }
                if (participantInfo.currentPage) {
                    if (participantInfo.currentPage.title) {
                        value.currentPageTooltip = participantInfo.currentPage.title;
                        value.currentPage = value.currentPageTooltip;
                    } else {
                        value.currentPageTooltip = this.translate('pageHasNoTitle');
                        value.currentPage = this.translate('pageHasNoTitle');
                    }
                } else {
                    value.currentPageTooltip = this.translate('notAvailable');
                    value.currentPage = this.translate('notAvailable');
                }
                value.numOfViewedPages = participantInfo.pageCount ? participantInfo.pageCount : 0;
                if (participantInfo.browser) {
                    var match = participantInfo.browser.match(/^([a-zA-Z]+).*$/); //the regex cuts the first word (browser name) of the string. e.g: 'Chrome 32.0.1700.76' will return 'chrome'
                    if (match) {
                        value.browser = match[1].toLowerCase();
                        value.browserTooltip = participantInfo.browser;
                    }
                    else {
                        value.browser = 'other';
                        value.browserTooltip = 'other';
                    }
                    if (participantInfo.browserIcon) {
                        value.browser = participantInfo.browserIcon.replace(' ', '_').toLowerCase();
                        if (this.supportedBrowserIcons.indexOf(value.browser) === -1) {
                            value.browser = 'other';
                        }
                        value.browserTooltip = participantInfo.browser;
                    }
                } else {
                    value.browserTooltip = this.translate('notAvailable');
                    value.browser = this.translate('notAvailable');
                }
                value.visitStartTime = participantInfo.visitStartTime ? this.formatTime(participantInfo.visitStartTime) : this.translate('notAvailable');
                if (agentLEManager.hasLiveEngage2Feature()) {
                    if (participantInfo.deviceFamily) {
                        value.deviceType = participantInfo.deviceFamily;
                        value.deviceTypeTooltip = this.translate("VISIT_INFO_Device_" + participantInfo.deviceFamily);
                    }
                    else {
                        value.deviceTypeTooltip = this.translate("VISIT_INFO_Device_NO_DEVICE");
                    }
                } else {
                    value.className += " hide_devices";
                }
                if (lpTag.WebAgent.logicController.hasAgentGroupsColumn()) {
                    if (participantInfo.agentGroupId && participantInfo.agentGroupName !== "") {
                        value.activeChatAgentGroup = participantInfo.agentGroupName;
                        value.activeChatAgentGroupTooltip = participantInfo.agentGroupName;
                    } else {
                        value.activeChatAgentGroup = this.translate('notAvailable');
                        value.activeChatAgentGroupTooltip = this.translate('notAvailable');
                    }
                } else {
                    value.className += " hide_agentGroups";
                }
                if (participantInfo.chatRequestTime || participantInfo.sessionStartTime) {
                    var startTime = participantInfo.chatRequestTime || participantInfo.sessionStartTime;
                    var endTime = participantInfo.chatAcceptTime || new Date().getTime();
                    var engLengthTexts = lpTag.WebAgent.logicController.getFormatDurationTime(endTime - startTime);

                    if (value.state == "waiting_for_chat") {
                        value.stateTooltip += this.translate('waitTimeTooltip_for') + engLengthTexts.tooltip;
                    } else if (value.state == "in_chat" && (endTime - startTime) >= 1000) { //don't show if the wait time is less than one second (e.g. on auto accept)
                        value.stateTooltip += this.translate('waitTimeTooltip_after') + engLengthTexts.tooltip;
                    }
                }
            }
            return value;
        }
    };

    VisitorListTableViewController.prototype.getColumnsData = function () {
        var columnsArray = [];
        var stateColumn =    {
                sortTag: "state",
                iconType: "header_status",
                iconState: "rep_wants_to_chat",
                tooltip: "visitorStateTooltip",
                tooltipAlign: "left"
            };
        var sentimentColumn =    {
                sortTag: "sentimentScore",
                iconType: "sentiment_header_status",
                iconState: "positive",
                tooltip: "sentimentTooltip",
                tooltipAlign: "left"
            };
        var visitorNameColumn =   {
                title: "visitorName",
                tooltip: "visitorNameTooltip"
            };
        var countryColumn = {
                sortTag: "country",
                title: "from",
                tooltip: "fromTooltip"
        };
        var skillColumn = {
            sortTag: "skill",
            title: "skill",
            tooltip: "skillTooltip"
        };
        var agentColumn = {
            sortTag: "agentNickName",
            title: "activeChatAgentName",
            tooltip: "activeChatAgentNameTooltip"
        };
        var agentGroupColumn = {
           // sortTag: "agentGroupId",
            title: "activeChatAgentGroup",
            tooltip: "activeChatAgentGroupTooltip"
        };
        var currentPageColumn = {
            sortTag: "current-page-title",
            title: "currentPage",
            tooltip: "currentPageTooltip"
        };
        var pageCountColumn = {
            title: "numOfViewedPages",
            tooltip: "numOfViewedPagesTooltip"
        };
        var deviceColumn = {
            sortTag: "device-family",
            title: "deviceFamily",
            tooltip: "deviceFamilyTooltip"
        };
        var browserColumn = {
            sortTag: "browser",
            iconType: "browser",
            iconState: "other",
            tooltip: "browserTooltip"
        };
        var startTimeColumn = {
            sortTag: "visitStartTime",
            title: "visitStartTime",
            tooltip: "visitStartTimeTooltip",
            tooltipAlign: "right"
        };
        if (lpTag.WebAgent.logicController.hasVisitorFeedQueryFeature()) {
            skillColumn.filter = {
                filterManager: FilterDropdownSelectionViewController,
                filterManagerData: {
                    className: "filter_dropdown_selection_view",
                    filterName: "skillIds",
                    filterTextSuffix: "skills",
                    filterDataModelPath: "skills.array",
                    publishProperty : "name",
                    minusOneData: {"id": -1, "name": this.translate('unassigned')}
                }
            };
            agentColumn.filter = {
                filterManager: FilterDropdownSelectionViewController,
                filterManagerData: {
                    className: "filter_dropdown_selection_view",
                    filterName: "agentIds",
                    filterTextSuffix: "agents",
                    filterDataModelPath: "operators.array",
                    textProperty: "fullName",
                    minusOneData: {"id": "-1", "fullName": this.translate('notAvailable')}
                }
            };

            // This is a temp disabling the sorting for this columns since under the new service they are not supported yet.
            delete currentPageColumn.sortTag;
        }
        columnsArray.push(
            stateColumn, //c1
            visitorNameColumn,//c2
            skillColumn,//c3
            agentColumn,//c4
            agentGroupColumn,//c5
            sentimentColumn,//c6
            countryColumn,//c7
            startTimeColumn,//c8
            currentPageColumn,//c9
            pageCountColumn,//c10
            deviceColumn,//c11
            browserColumn//c12
        );

        return columnsArray;
    };

    VisitorListTableViewController.prototype.getWidgetsData = function () {
        var widgetsData = [];
        var allChatsPrivilege = privilegesController.hasViewAllChatsPrivilege();
        var skillChatPrivilege = privilegesController.hasViewSkillChatsPrivilege();

        //if the agent has a privilege to view transcripts, or skill chats, allow them to see transcripts
        if (allChatsPrivilege || skillChatPrivilege) {
            widgetsData.push({
                widgetType: VisitorListEngagementWidget, //the widget that shows transcript
                widgetData: {
                    itemIdTag: "rtSessionId",
                    chatsRootModelPath: "chats"
                }
            });
        }
        if (lpTag.WebAgent.visitorInfoController) { // TEMP: remove this if after VisitInfoWidget is stable
            widgetsData.push({
                widgetType: VisitInfoWidget,
                widgetData: {
                    itemIdTag: "id"
                }
            }, {
                widgetType: PageNavigationWidget,
                widgetData: {}
            });
        } else {
            widgetsData.push({
                widgetType: VisitorInfoWidget,
                widgetData: {
                    itemIdTag: "id"
                }
            });
        }
        return widgetsData;
    };

    return VisitorListTableViewController;

});
